import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { myTheme } from '../../../../../shared/theme';

export default function PendingReportGraph(params: any) {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const boat = params?.data?.filter((i: any) => i.moduleType === 'boat');
    const vehicle = params?.data?.filter(
        (i: any) => i.moduleType === 'vehicle',
    );
    const property = params?.data?.filter(
        (i: any) => i.moduleType === 'property',
    );
    const activity = params?.data?.filter(
        (i: any) => i.moduleType === 'activity',
    );
    const commercial = params?.data?.filter(
        (i: any) => i.moduleType === 'commercial',
    );

    const totalCancellations = [
        { name: 'Boat', pendingTotal: boat?.length },
        { name: 'Vehicle', pendingTotal: vehicle?.length },
        { name: 'Property', pendingTotal: property?.length },
        { name: 'Activity', pendingTotal: activity?.length },
        { name: 'Commercial', pendingTotal: commercial?.length },
    ];

    return (
        <Box
            sx={{
                height: isMobile ? 400 : 800,
                width: '100%',
                paddingTop: isMobile ? '0px' : '50px',
            }}
        >
            <BarChart
                tooltip={{ trigger: 'item' }}
                xAxis={[
                    {
                        id: 'barCategories',
                        data: totalCancellations.map(
                            (reservation: { name: any }) => reservation?.name,
                        ),
                        scaleType: 'band',
                    },
                ]}
                series={[
                    {
                        data: totalCancellations.map(
                            (reservation: { pendingTotal: any }) =>
                                reservation?.pendingTotal,
                        ),
                        color: myTheme.secondary.main,
                    },
                ]}
                // width={2500}
                // height={300}
            />
        </Box>
    );
}
